export default function capitalize(string = '') {
  if (!string.length || string.length <= 1) return string;

  return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
}
